import axios from 'axios';
import qs from 'qs';
import config from './config';
import storage from '@/js/utils/storage';
import comm from '@/js/utils/common';
import { MessageBox, Loading } from 'element-ui';
axios.defaults.baseURL = config.api;
axios.defaults.withCredentials = false;
const _axios = function (opt) {
    let options = opt.data;
    // 清除空数据和数字类型数据转换
    // options = comm.convertParams(options);
    // if (!opt.isFormData) {
    //     options = comm.convertParams(options);
    // }
    axios.defaults.headers.common['Authorization'] = storage.LStorage.get('_tAdmin');
    if (config.debug) {
        let _debugApi = comm.querystring('debugapi');
        _debugApi && (opt.url = _debugApi + opt.url);
    }

    let tempParams;
    if (opt.isBlob) {
        //设置返回数据为blob
        console.log('kiii', axios.defaults);
        axios.defaults.responseType = 'blob';
    } else {
        axios.defaults.responseType = 'json';
    }
    // 数据提交类型
    if (opt.isBody) {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        axios.defaults.headers.put['Content-Type'] = 'application/json';
        axios.defaults.headers.delete['Content-Type'] = 'application/json';
        tempParams = JSON.stringify(options);
    } else {
        axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        tempParams = qs.stringify(options);
    }
    if (opt.type == 'post') {
        return axios.post(opt.url, tempParams);
    } else if (opt.type == 'get') {
        return axios.get(opt.url, { params: options });
    } else if (opt.type == 'put') {
        return axios.put(opt.url, tempParams);
    } else if (opt.type == 'delete') {
        return axios.delete(opt.url, { data: options });
    }
};
/*************参数组成*************/
/* opt = {
    url: '',
    type: '',//列如get
    data: {},//传入参数
    success: function() {},//接口调用成功,status为true
    success_false: function() {},//接口调用成功,status为false
    failure: function() {},//接口调用失败
    isLoading:false //禁止显示loading，为true关闭loading
}*/
export const _http = (opt) => {
    let $Loading;
    if (opt.isLoading) {
        $Loading = Loading.service({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    }
    _axios(opt)
        .then((res) => {
            if (opt.isBlob) {
                let httpRes = res.data;
                console.log(httpRes);
                const file = new FileReader();
                file.readAsText(httpRes, 'utf-8');
                // let message
                file.onload = function () {
                    try {
                        const message = JSON.parse(file.result);
                        MessageBox.alert(message.msg, '系统提示', {
                            confirmButtonText: '确定',
                            callback: (action) => {}
                        });
                        opt.success_false && opt.success_false();
                        console.log('bcbcbcbcbzzzzzzz');
                    } catch (error) {
                        opt.success && opt.success(res);
                    }

                    //  console.log(message);
                    // //此时message为转化好的json格式
                    // if (message.code == '400') {

                    // } else {

                    // }
                };
            } else {
                let httpRes = res.data;
                let tempOptions = comm.convertParams(opt.data);
                console.log('');
                console.log('api:', opt.url);
                if (opt.isBody) {
                    console.log('api传入参数：', JSON.stringify(tempOptions));
                } else {
                    console.log('api传入参数：\n', qs.stringify(tempOptions).replace(/=/g, ':').replace(/&/g, '\n'));
                }
                console.log('api返回数据：', httpRes);
                console.log('');
                // 接口调用成功,状态为true
                if (httpRes.success) {
                    opt.success && opt.success(httpRes);
                } else if (httpRes.code == '403') {
                    MessageBox.alert('登录超时', '系统提示', {
                        confirmButtonText: '确定',
                        callback: (action) => {
                            // 登录超时，退回登录页
                            comm.logout(() => {
                                location.href = '/';
                            });
                        }
                    });
                    opt.success_false && opt.success_false();
                } else if (httpRes.code == '502') {
                    MessageBox.alert('请求错误', '系统提示', {
                        confirmButtonText: '确定',
                        callback: (action) => {}
                    });
                    opt.success_false && opt.success_false();
                } else if (httpRes.code == '441') {
                    console.log('httpRes.message->' + httpRes.message);
                    MessageBox.alert(httpRes.msg || '数据验证失败', '系统提示', {
                        confirmButtonText: '确定',
                        callback: (action) => {}
                    });
                    opt.success_false && opt.success_false();
                } else if (httpRes.code == '442') {
                    MessageBox.alert(httpRes.msg || '网络异常', '系统提示', {
                        confirmButtonText: '确定',
                        callback: (action) => {}
                    });
                    opt.success_false && opt.success_false();
                }
                // 接口调用错误提示
                else {
                    MessageBox.alert(httpRes.msg, '系统提示', {
                        confirmButtonText: '确定',
                        callback: (action) => {}
                    });
                    opt.success_false && opt.success_false();
                    console.log('bcbcbcbcbzzzzzzz');
                }
                $Loading && $Loading.close();
            }
        })
        .catch((err) => {
            console.log('接口错误信息------------->', err);
            let httpResponse = err.response;
            if (httpResponse && httpResponse.data.code == 442) {
                MessageBox.alert(httpResponse.data.msg || '网络异常', '系统提示', {
                    confirmButtonText: '确定',
                    callback: (action) => {}
                });
            } else {
                MessageBox.alert('网络异常', '系统提示', {
                    confirmButtonText: '确定',
                    callback: (action) => {}
                });
            }
            $Loading && $Loading.close();
        });
};



// WEBPACK FOOTER //
// ./src/js/utils/http.js